import React from 'react'

import ExamSubmitButton from '@components/Button/ExamSubmitButton'
import MovePageButton from '@components/Button/MovePageButton'

type FooterProps = {
  viewResultMode: boolean
  setShowSubmitModal: (trueFalse: boolean) => void
  currentPage: number
  totalPage: number
  bottomNumber: string
  isDelivery?: boolean
}

const Footer: React.FC<FooterProps> = ({
  viewResultMode,
  setShowSubmitModal,
  currentPage,
  totalPage,
  bottomNumber,
  isDelivery,
}) => {
  const examSubmitButtonProps = {
    viewResultMode,
    setShowSubmitModal,
    isDelivery,
  }
  return (
    <div
      className={
        'max-[640px]:fixed max-[640px]:bottom-0 sm:flex-none h-20 w-full sm:w-[1024px] lg:w-full bg-f4f4f4'
      }
    >
      <div className="border-b-2 border-gray-100" />
      <div className="flex h-full">
        <div className={'flex pr-10 sm:pr-0 mx-auto my-auto'}>
          <MovePageButton isVisible={currentPage > 1} isBackward={true} />
          <h2 className={'text-lg sm:text-2xl font-bold my-auto'}>
            {bottomNumber}/{String(totalPage).padStart(2, '0')}
          </h2>
          <MovePageButton isVisible={currentPage < totalPage} isBackward={false} />
        </div>
        <div className={'my-auto pr-2'}>{<ExamSubmitButton {...examSubmitButtonProps} />}</div>
      </div>
    </div>
  )
}

export default Footer
